export function PlaceholderWidget({ label }: { label: string }) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        background: 'rgba(168, 85, 247, 0.15)',
        border: '1px dashed rgba(168, 85, 247, 0.6)',
        color: 'white',
        display: 'grid',
        placeItems: 'center',
        fontFamily: 'system-ui, sans-serif',
        fontSize: 12,
        letterSpacing: 1,
      }}
    >
      {label}
    </div>
  );
}
